import React, { useEffect, useState } from "react";
import { sendToAndroid } from "../services/androidBridge";
import {
  history,
  language,
  scheduleListLanguageOptions,
  schedulePaymentLanguageOptions,
} from "./dropdown/dropdown-data";
import { Dropdown } from "./dropdown/Dropdown";
import { GoAlertFill } from "react-icons/go";
import { InputText } from "primereact/inputtext";

import { Datepicker } from "flowbite-react";
import "react-day-picker/dist/style.css";
import { Button } from "primereact/button";

import { IoCloseCircleOutline } from "react-icons/io5";
import InstallmentCard from "./InstallmentCard";

import { InstallDropdown } from "./dropdown/InstallDropDown";

export default function SchedulePayment() {
  const [amount, setAmount] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [selectedAccount, setSelectedAccount] = useState("");
  const [selectedAccountDetail, setSelectedAccountDetail] = useState("");
  const [selectedTypeList, setSelectedTypeList] = useState("");
  const [accountList, setAccountList] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isStartProvided, setIsStartProvided] = useState("");
  const [isEndProvided, setIsEndProvided] = useState("");
  const [onConfirm, setOnConfirm] = useState("");
  const [onReqConfirm, setOnReqConfirm] = useState(null);
  const [transferRequest, setTransferRequest] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const [title, setTitle] = useState();
  const [reason, setReason] = useState();
  const [detaillist, setDetailList] = useState([]);
  const [detailUpdatelist, setDetailUpdateList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [toAccountInfo, setToAccountInfo] = useState(true);
  const [toAccountInfoDesc, setToAccountInfoDesc] = useState(true);

  const [selectedType, setSelectedType] = useState("");
  const [toAccount, setToAccount] = useState("");
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [isAccountDetailOpen, setIsAccountDetailOpen] = useState(false);
  const [isSearchListOpen, setSearchListOpen] = useState(false);
  const [isTypeOpen, setIsTypeOpen] = useState(false);
  const [isDetail, setIsDetail] = useState(false);
  const [accountRequired, setAccountRequired] = useState("");
  const [accountDetailRequired, setAccountDetailRequired] = useState("");
  const [typeRequired, setTypeRequired] = useState("");
  const [toAccountRequired, setToAccountRequired] = useState("");
  const [frequence, setFrequence] = useState("");
  const [isAmountProvided, setIsAmountProvided] = useState("");
  const [isPaymentProvided, setIsPaymentProvided] = useState("");
  const [isReasonProvided, setIsReasonProvided] = useState("");
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmReqMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [jwt, setJwt] = useState(0);
  const [userName, setUserName] = useState("");
  const [warning] = useState("");
  const [accountRequest, setAccountRequest] = useState("");
  const [updateRequest, setUpdateRequest] = useState(null);
  const [toAccountHolder, setToAccountHolder] = useState("");
  const [, setIsFrom] = useState("true");
  const handleDateChange = (date) => {
    // Keep the full format for the selected date
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}T${date
      .getHours()
      .toString()
      .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date
      .getSeconds()
      .toString()
      .padStart(2, "0")}`;

    // Format today's date only to "YYYY-MM-DD" for comparison
    const today = new Date();
    const formattedToday = `${today.getFullYear()}-${(today.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;

    // Extract only the "YYYY-MM-DD" portion of the selected date for comparison
    const dateForComparison = formattedDate.split("T")[0];

    // Validate that the selected date is not earlier than today
    if (dateForComparison < formattedToday) {
      setErrorMessage("Start date cannot be earlier than today.");
      return;
    }

    setStartDate(formattedDate);
    setIsStartProvided("");

    // Optional: Reset end date if it was set and now invalid
    if (endDate && formattedDate > endDate) {
      setEndDate("");
      setErrorMessage("End date cannot be before start date.");
    }
  };

  const handleEndDateChange = (date) => {
    // Adjust for timezone offset
    const localDate = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    );

    // Format the date to "YYYY-MM-DDTHH:mm:ss"
    const formattedDate = `${localDate.getFullYear()}-${(
      localDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${localDate
      .getDate()
      .toString()
      .padStart(2, "0")}T${localDate
      .getHours()
      .toString()
      .padStart(2, "0")}:${localDate
      .getMinutes()
      .toString()
      .padStart(2, "0")}:${localDate.getSeconds().toString().padStart(2, "0")}`;

    // Extract only the "YYYY-MM-DD" portion of the formattedDate and startDate for comparison
    const endDateForComparison = formattedDate.split("T")[0];
    const startDateForComparison = startDate.split("T")[0];

    // Validate that the end date is not earlier than the start date
    if (endDateForComparison < startDateForComparison) {
      setErrorMessage("End date cannot be earlier than the start date.");
      return;
    }

    setEndDate(formattedDate);
    setIsEndProvided("");
  };
  useEffect(() => {
    setDetailList(detailUpdatelist);
  }, [detailUpdatelist]);
  const handleFirstRender = (request) => {
    sendDataToAndroid(request);
  };
  const frequencies = [
    ["DAILY", "WEEKLY", "BI_WEEKLY", "MONTHLY", "CUSTOM"],
    ["በየቀኑ", "በየሳምንቱ", "ከሁለት ሳምንት አንድ ጊዜ", "በየወሩ", "የተበጀ"],
    [
      "GUYYAA GUYYAATTI",
      "TORBEE TORBEE",
      "Torban lama lamatti",
      "JI'A JI'AN",
      "AADAA",
    ],
    ["መዓልታዊ", "ሰሙናዊ", "ኣብ ነፍሲ ወከፍ ክልተ ሰሙን", "ወርሓዊ", "ብዓይነት ዝተዳለወ"],
    [
      "MAALIN WALBA",
      "TODDOBAADKII",
      "Labadii toddobaadba mar",
      "BISHII",
      "LA HABSANAY",
    ],
    ["KULLI AYRO", "AYAM", "Kulli namma ayyaamat", "Alsi", "massos"],
  ];
  const frequenceTypeList = [
    {
      id: 1,
      label: frequencies[jwt]?.[0],
      value: "DAILY",
    },
    {
      id: 2,
      label: frequencies[jwt]?.[1],
      value: "WEEKLY",
    },
    {
      id: 3,
      label: frequencies[jwt]?.[2],
      value: "BI_WEEKLY",
    },
    {
      id: 4,
      label: frequencies[jwt]?.[3],
      value: "MONTHLY",
    },
    {
      id: 5,
      label: frequencies[jwt]?.[4],
      value: "CUSTOM",
    },
  ];
  const handleIsAccountOpen = () => {
    setIsAccountOpen(!isAccountOpen);
  };
  const handleIsAccountDetailOpen = () => {
    setIsAccountDetailOpen(!isAccountDetailOpen);
  };
  const handleIsTypeOpen = () => {
    setIsTypeOpen(!isTypeOpen);
  };
  const handleIsSearchOpen = () => {
    setSearchListOpen(!isSearchListOpen);
  };
  const handleAccountSelection = (option) => {
    setSelectedAccount(option);
    handleIsAccountOpen();
  };

  const handleAccountDetailSelection = (option) => {
    setSelectedAccountDetail(option);
    handleIsAccountDetailOpen();
    setAccountRequest({ from_account: option });
  };
  const handlePaymentSelection = (option) => {
    setSelectedTypeList(option);
    handleIsSearchOpen();
    // setAccountRequest({ from_account: option });
  };
  const handleTypeSelection = (option) => {
    setSelectedType(option);
    handleIsTypeOpen();
  };
  const handleListData = (option) => {
    // Ensure it's an array
    setDetailUpdateList(option);
    setDetailList([]);
    handleIsSearchOpen();
    // handleIsTypeOpen();
  };
  const handleFrequenceChange = (e) => {
    setFrequence(e.target.value);
    // setIsPnrProvided("");
  };
  const handleToAccountChange = (e) => {
    setToAccount(e.target.value);

    setToAccountRequired("");
  };
  const handleAmountChange = (e) => {
    setAmount(e.target.value);

    setIsAmountProvided("");
  };
  const handlePaymentChange = (e) => {
    setPaymentType(e.target.value);

    setIsPaymentProvided("");
  };
  const handleReasonChange = (e) => {
    setReason(e.target.value);

    setIsReasonProvided("");
  };
  const getDataFromAndroid = () => {
    window.receiveDataFromAndroid = (data) => {
      console.log("data", data);
      const dataString = JSON.stringify(data);
      const obj = JSON.parse(dataString);
      const objName = JSON.parse(obj.request).name;
      const objData = JSON.parse(obj.response).data;
      const urlFromResponse = JSON.parse(obj.request).url;

      switch (objName) {
        case "accountList":
          getAccountListFromAndroid(obj, objData);
          break;
        case "confirmResponse":
          setOnConfirm("true");
          break;
        case "confirmReqResponse":
          setOnReqConfirm("true");
          break;
        case "jwt":
          setJwt(objData);
          break;
        case "response":
          // setExtractedUrl(urlFromResponse);
          handleDataBasedOnUrl(urlFromResponse, objData);
          break;
        case "userName":
          setUserName(objData);
          break;
        default:
          break;
      }
    };
  };
  const getAccountListFromAndroid = (obj, objData) => {
    if (obj.response !== undefined && objData !== undefined) {
      let uniqueAccountList = [];
      JSON.parse(objData).forEach((account) => {
        uniqueAccountList = [
          ...uniqueAccountList,
          { label: account.accounts, value: account.accounts },
        ];
        setAccountList([...uniqueAccountList]);
      });
    }
  };
  const handleDataBasedOnUrl = (url, responseData) => {
    if (url.includes(`scheduledPayment-1.0-SNAPSHOT/rest/InstallmentDetail`)) {
      const parsedResponse = JSON.parse(responseData);
      setSearchList(parsedResponse.data);
      // setDetailList(parsedResponse.data);
    } else if (
      url.includes("scheduledPayment-1.0-SNAPSHOT/rest/InstallmentCreation")
    ) {
      const parsedResponse = JSON.parse(responseData);
      if (parsedResponse.stastus) {
        setSuccessMessage(parsedResponse.desc);
        setErrorMessage("");
      } else {
        setErrorMessage(parsedResponse.desc);
        setSuccessMessage("");
      }
    } else if (
      url.includes("scheduledPayment-1.0-SNAPSHOT/rest/updatePayment")
    ) {
      const parsedResponse = JSON.parse(responseData);
      if (parsedResponse.status) {
        setSuccessMessage(parsedResponse.responseDesc);
        setErrorMessage("");
      } else {
        setErrorMessage(parsedResponse.responseDesc);

        setSuccessMessage("");
      }
    }
    if (url.includes("InternalAccountInfo/rest/internal")) {
      const parsedResponse = JSON.parse(responseData);
      if (parsedResponse.status) {
        setToAccountHolder(parsedResponse.name);
        setErrorMessage("");
        setIsFrom(false);
        setToAccountInfo(true);
      } else {
        setErrorMessage(parsedResponse.desc);
        setSuccessMessage("");
        setToAccountInfoDesc(parsedResponse.desc);
        setToAccountInfo(false);
      }
    }
  };
  useEffect(() => {
    sendDataToAndroid("first");
    getDataFromAndroid();
  }, []);
  useEffect(() => {
    if (updateRequest !== null) {
      sendDataToAndroid("confirmReq");
    }
  }, [updateRequest]);
  useEffect(() => {
    if (toAccount.length === 13) {
      sendDataToAndroid("info");
    }
  }, [toAccount]);
  useEffect(() => {
    if (toAccountHolder !== "") {
    }
  }, [toAccountHolder]);
  useEffect(() => {
    if (onReqConfirm !== null) {
      sendDataToAndroid("update");
    }
  }, [onReqConfirm]);
  useEffect(() => {
    setTitle(scheduleListLanguageOptions[jwt]);
  }, [jwt]);
  useEffect(() => {
    if (selectedAccountDetail !== "") {
      sendDataToAndroid("detail");
    }
  }, [selectedAccountDetail]);
  useEffect(() => {
    if (title !== null) {
      handleFirstRender("title");
    }
  }, [title]);

  useEffect(() => {
    if (confirmMessage !== "") {
      handleFirstRender("confirm");
    }
  }, [confirmMessage]);
  useEffect(() => {
    if (successMessage !== "") {
      handleFirstRender("success");
    }
  }, [successMessage]);

  useEffect(() => {
    if (errorMessage !== null) {
      handleFirstRender("warning");
    }
  }, [errorMessage]);
  useEffect(() => {
    if (!loading) {
      handleFirstRender("openLoading");
    }
  }, [loading]);

  useEffect(() => {
    if (!closeLoading) {
      handleFirstRender("openLoading");
      if (closeLoading) {
        setLoading(false);
        setCloseLoading(false);
      }
    }
  }, [closeLoading]);
  useEffect(() => {
    if (warning !== "") {
      handleFirstRender("warning");
    }
  }, [warning]);

  useEffect(() => {
    if (onConfirm !== "") {
      handleFirstRender("requestTransfer");
    } else {
    }
  }, [onConfirm]);
  const handleTransfer = () => {
    if (
      !selectedType ||
      !toAccount ||
      !amount ||
      !startDate ||
      !endDate ||
      !paymentType
    ) {
      setAccountRequired(!selectedAccount && "Please select an account");
      setIsAmountProvided(!amount && "Please enter the amount");
      setTypeRequired(!selectedType && "Please select  type");
      setIsStartProvided(!startDate && "Please select start date");
      setIsEndProvided(!endDate && "Please enter end date");
      setToAccountRequired(!toAccount && "Please enter to account");
      setIsReasonProvided(!isReasonProvided && "");
      setIsPaymentProvided(!paymentType && "please enter payment");
      return;
    }
    const message =
      `<b>From Account: </b> ${selectedAccount} <br><br>` +
      // `<b>From Account Name: </b> ${fromAccountHolder} <br><br>` +
      `<b>To Account: </b> ${toAccount} <br><br>` +
      `<b>To Account Name: </b> ${toAccountHolder} <br><br>` +
      `<b>Schedule Frequency :</b> ${selectedType.value} <br><br>` +
      (selectedType === "CUSTOM"
        ? `<b>Frequency(Days): </b> ${frequence} <br><br>`
        : "") +
      `<b>Payment Type: </b> ${paymentType} <br><br>` +
      `<b>StartDate: </b> ${startDate} <br><br>` +
      `<b>EndDate: </b> ${endDate} <br><br>` +
      `<b>Amount: </b> ${amount} <br><br>` +
      `<b>Reason: </b> ${reason} <br><br> `;
    setConfirmMessage(message);

    setTransferRequest({
      fromAcc: selectedAccount,
      toAcc: toAccount,
      fromAccName: userName,
      toAccName: toAccountHolder,
      scheduleFrequency: selectedType.value,
      frequency: frequence,
      start: startDate,
      endDate: endDate,
      amount: amount,
      reason: reason,
      paymentType: paymentType,
    });
  };

  const sendDataToAndroid = (name) => {
    var transferData = {
      transferData: [],
    };
    if (name === "return") {
      transferData = {
        transferData: [
          {
            type: "return",
            request: { name: "graphData" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "title") {
      transferData = {
        transferData: [
          {
            type: "title",
            request: { name: "title" },
            response: { data: title },
            name: "",
          },
        ],
      };
    } else if (name === "first") {
      transferData = {
        transferData: [
          {
            type: "first",
            request: { name: "first" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "confirm") {
      transferData = {
        transferData: [
          {
            type: "confirm",
            request: { name: "confirm" },
            response: { data: confirmMessage },
            name: "",
          },
        ],
      };
    } else if (name === "confirmReq") {
      transferData = {
        transferData: [
          {
            type: "confirmRequest",
            request: { name: "confirm" },
            response: { data: confirmReqMessage },
            name: "Confirm Status Update",
          },
        ],
      };
    } else if (name === "openLoading") {
      transferData = {
        transferData: [
          {
            type: "openLoading",
            request: { name: "openLoading" },
            response: { data: loading },
            name: "",
          },
        ],
      };
    } else if (name === "closeLoading") {
      transferData = {
        transferData: [
          {
            type: "closeLoading",
            request: { name: "closeLoading" },
            response: { data: closeLoading },
            name: "",
          },
        ],
      };
    } else if (name === "fromaccount") {
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: {
              name: `InternalAccountInfo/rest/internal`,
            },
            response: {
              data: JSON.stringify({ account_number: selectedAccount }),
            },
            name: "",
          },
        ],
      };
    } else if (name === "update") {
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: {
              name: `scheduledPayment-1.0-SNAPSHOT/rest/updatePayment`,
            },
            response: { data: JSON.stringify(updateRequest) },
            name: "",
          },
        ],
      };
    } else if (name === "info") {
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: {
              name: `InternalAccountInfo/rest/internal`,
            },
            response: { data: JSON.stringify({ account_number: toAccount }) },
            name: "",
          },
        ],
      };
    } else if (name === "detail") {
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: {
              name: `scheduledPayment-1.0-SNAPSHOT/rest/InstallmentDetail`,
            },
            response: { data: JSON.stringify(accountRequest) },
            name: "",
          },
        ],
      };
    } else if (name === "warning") {
      transferData = {
        transferData: [
          {
            type: "warning",
            request: { name: "warning" },
            response: { data: errorMessage },
            name: "",
          },
        ],
      };
    } else if (name === "error") {
      transferData = {
        transferData: [
          {
            type: "error",
            request: { name: "error" },
            response: { data: errorMessage },
            name: "",
          },
        ],
      };
    } else if (name === "success") {
      transferData = {
        transferData: [
          {
            type: "success",
            request: { name: "success" },
            response: { data: successMessage },
            name: "",
          },
        ],
      };
    } else if (name === "requestTransfer") {
      transferData = {
        transferData: [
          {
            type: "requestPost",
            request: {
              name: "scheduledPayment-1.0-SNAPSHOT/rest/InstallmentCreation",
            },
            response: { data: JSON.stringify(transferRequest) },
            name: "",
          },
        ],
      };
    }
    console.log("info: ", JSON.stringify(transferData));
    sendToAndroid(transferData);
    setConfirmMessage("");
    setOnConfirm("");
    setErrorMessage("");
  };
  return (
    <div
      className="service-screen w-full max-w-md mx-auto px-4 pt-2"
      style={{
        overflow: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <div
        className="items-end justify-self-end pb-2"
        onClick={() => setIsDetail(!isDetail)}
      >
        {isDetail ? (
          <IoCloseCircleOutline className="justify-end w-8 h-8" />
        ) : (
          <Button
            label={history[jwt]}
            severity="info"
            icon="pi pi-arrow-right"
            // onClick={handleTransfer}
            size="small"
            className=" text-[12px] p-button-success p-4 pl-6 pr-6 bg-[#0351b3] text-[#ffffff] hover:bg-blue-800 rounded-xl font-semibold"
          />
        )}
      </div>
      {isDetail ? (
        <div className="mb-4 font-light py-auto">
          <label className="block text-[#808080] mb-2 text-lg font-semibold">
            {schedulePaymentLanguageOptions[jwt]?.labels[0]}
          </label>
          <div className=" mb-10">
            <Dropdown
              options={accountList}
              id={"account"}
              placeholder={schedulePaymentLanguageOptions[jwt]?.placeholder[0]}
              isOpen={isAccountDetailOpen}
              selectedAccount={selectedAccountDetail}
              selectedOrganization={selectedType}
              handleSelection={handleAccountDetailSelection}
              handleDropDown={handleIsAccountDetailOpen}
              setAccountRequired={setAccountDetailRequired}
            />
            {accountDetailRequired && (
              <p className="warnings">
                <GoAlertFill />
                {schedulePaymentLanguageOptions[jwt]?.valueError[0]}
              </p>
            )}
          </div>
          {searchList.length > 0 && (
            <>
              <label className="block text-[#808080] mb-2 text-lg font-semibold">
                {schedulePaymentLanguageOptions[jwt]?.placeholder[3]}
              </label>
              <InstallDropdown
                options={searchList}
                placeholder={
                  schedulePaymentLanguageOptions[jwt]?.placeholder[3]
                }
                isOpen={isSearchListOpen}
                selectedAccount={selectedTypeList}
                handleSelectedList={handleListData}
                handleSelection={handlePaymentSelection}
                handleDropDown={handleIsSearchOpen}
                setAccountRequired={setAccountDetailRequired}
              />
            </>
          )}
          ,
          {detaillist && detaillist.length > 0 ? (
            <InstallmentCard
              datas={detaillist}
              setUpdate={setUpdateRequest}
              jwt={jwt}
              setOnReqConfirm={setOnReqConfirm}
            />
          ) : (
            <></>
          )}
        </div>
      ) : (
        <div className="mb-4 font-light">
          <label className="block text-[#808080] mb-2 text-lg font-semibold">
            {schedulePaymentLanguageOptions[jwt]?.labels[0]}
          </label>
          <div>
            <Dropdown
              options={accountList}
              id={"account"}
              placeholder={schedulePaymentLanguageOptions[jwt]?.placeholder[0]}
              isOpen={isAccountOpen}
              selectedAccount={selectedAccount}
              selectedOrganization={selectedType}
              handleSelection={handleAccountSelection}
              handleDropDown={handleIsAccountOpen}
              setAccountRequired={setAccountRequired}
            />
            {accountRequired && (
              <p className="warnings">
                <GoAlertFill />
                {schedulePaymentLanguageOptions[jwt]?.valueError[0]}
              </p>
            )}
          </div>
          <div>
            <label className="block text-[#808080] mb-2 text-lg font-semibold">
              {schedulePaymentLanguageOptions[jwt]?.labels[8]}
            </label>
            <InputText
              id="toAcc"
              type="text"
              placeholder={schedulePaymentLanguageOptions[jwt]?.placeholder[1]}
              value={toAccount}
              onChange={handleToAccountChange}
              className="w-full outline-none border-2 border-slate-600 text-lg p-3 rounded-xl bg-[#f5f5f5]"
            />
            {(toAccountRequired || !toAccountInfo) && (
              <p className="amountwarning warnings">
                <GoAlertFill />
                {toAccountInfo
                  ? schedulePaymentLanguageOptions[jwt].valueError[8]
                  : toAccountInfoDesc}
              </p>
            )}
            {toAccountHolder && (
              <p className="text-[#0351b3]  text-end">{toAccountHolder}</p>
            )}
          </div>
          <label className="block text-[#808080] mt-2 mb-2 text-lg font-semibold">
            {schedulePaymentLanguageOptions[jwt]?.labels[1]}
          </label>
          <div>
            <Dropdown
              options={frequenceTypeList}
              id="type"
              placeholder={schedulePaymentLanguageOptions[jwt]?.placeholder[2]}
              isOpen={isTypeOpen}
              selectedAccount={selectedAccount}
              selectedOrganization={selectedType}
              handleSelection={handleTypeSelection}
              handleDropDown={handleIsTypeOpen}
              setAccountRequired={setAccountRequired}
              setOrganizationRequired={setTypeRequired}
            />
            {typeRequired && (
              <p className="warnings">
                <GoAlertFill />
                {schedulePaymentLanguageOptions[jwt]?.valueError[1]}
              </p>
            )}
          </div>
          {selectedType.value === "CUSTOM" && (
            <div>
              <label className="block text-[#808080] mb-2 text-lg font-semibold">
                {schedulePaymentLanguageOptions[jwt]?.labels[2]}
              </label>
              <InputText
                id="frequence"
                type="text"
                value={frequence}
                onChange={handleFrequenceChange}
                className="w-full outline-none border-2 border-slate-600 text-lg p-3 rounded-xl bg-[#f5f5f5]"
              />
              {!frequence && (
                <p className="amountwarning warnings">
                  <GoAlertFill />
                  {schedulePaymentLanguageOptions[jwt]?.valueError[2]}
                </p>
              )}
            </div>
          )}
          <div>
            <label className="block text-[#808080] mb-2 text-lg font-semibold">
              {schedulePaymentLanguageOptions[jwt]?.labels[7]}
            </label>
            <InputText
              id="paymentType"
              type="text"
              value={paymentType}
              onChange={handlePaymentChange}
              className="w-full outline-none border-2 border-slate-600 text-lg p-3 rounded-xl bg-[#f5f5f5]"
            />
            {isPaymentProvided && (
              <p className="amountwarning warnings">
                <GoAlertFill />
                {schedulePaymentLanguageOptions[jwt]?.valueError[7]}
              </p>
            )}
          </div>
          <label className="block text-[#808080] pt-2 mb-2 text-lg font-semibold">
            {schedulePaymentLanguageOptions[jwt]?.labels[3]}
          </label>
          <div className="flex items-center gap-x-6 py-2">
            <Datepicker
              value={startDate}
              onChange={handleDateChange}
              placeholder={schedulePaymentLanguageOptions[jwt]?.labels[3]}
            />
          </div>
          {isStartProvided && (
            <p className="amountwarning warnings">
              <GoAlertFill />
              {schedulePaymentLanguageOptions[jwt]?.valueError[3]}
            </p>
          )}
          <label className="block text-[#808080] mb-2 text-lg font-semibold">
            {schedulePaymentLanguageOptions[jwt].labels[6]}
          </label>
          <div className="flex items-center gap-x-6 py-2">
            <Datepicker
              value={endDate}
              onChange={handleEndDateChange}
              placeholder={schedulePaymentLanguageOptions[jwt]?.labels[6]}
            />
          </div>
          {isEndProvided && (
            <p className="amountwarning warnings">
              <GoAlertFill />
              {schedulePaymentLanguageOptions[jwt]?.valueError[6]}
            </p>
          )}
          <div>
            <label className="block text-[#808080] mb-2 text-lg font-semibold">
              {schedulePaymentLanguageOptions[jwt]?.labels[4]}
            </label>
            <InputText
              id="amount"
              type="number"
              value={amount}
              onChange={handleAmountChange}
              className="w-full outline-none border-2 border-slate-600 text-lg p-3 rounded-xl bg-[#f5f5f5]"
            />
            {isAmountProvided && (
              <p className="amountwarning warnings">
                <GoAlertFill />
                {schedulePaymentLanguageOptions[jwt].valueError[4]}
              </p>
            )}
          </div>
          <div>
            <label className="block text-[#808080] mb-2 text-lg font-semibold">
              {schedulePaymentLanguageOptions[jwt]?.labels[5]}
            </label>
            <InputText
              id="reason"
              type="text"
              value={reason}
              onChange={handleReasonChange}
              className="w-full outline-none border-2 border-slate-600 text-lg p-3 rounded-xl bg-[#f5f5f5]"
            />
            {isReasonProvided !== "" && (
              <p className="amountwarning warnings">
                <GoAlertFill />
                {schedulePaymentLanguageOptions[jwt]?.valueError[5]}
              </p>
            )}
          </div>
          <div className="flex justify-center items-center">
            <label></label>
            {
              <Button
                label={language[jwt]?.button}
                severity="info"
                icon="pi pi-arrow-right"
                onClick={handleTransfer}
                size="small"
                className="mt-4 text-[12px] p-button-success p-5 pl-12 pr-12 bg-[#0351b3] text-[#ffffff] hover:bg-blue-800 rounded-xl font-semibold"
              />
            }
          </div>
        </div>
      )}
    </div>
  );
}
